window.dataLayer = window.dataLayer || [];

export function gtag() {
  window.dataLayer.push(arguments);
}

export function quoteEventPayload(quote) {
  return {
    range_name: quote.range.name,
    range_handle: quote.range.handle,
    order_ref: quote.ref,
    order_price: parseFloat(quote.total)
  };
}

export function trackQuoteEvent(eventName, quote) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    range_name: quote.range.name,
    range_handle: quote.range.handle,
  });

  const pushData = quoteEventPayload(quote);
  console.log('trigger: ' + eventName);
  console.log(pushData);
  if (typeof dataLayer !== 'undefined') gtag('event', eventName, pushData);
}
